import * as apigw from "@/lib/apigw"

export const getUserDb = async (opts?: any): Promise<any> => {
  const res = await apigw.request("/user/get-user", opts)
  return res
}
